import React from 'react';

interface LoadingSpinnerProps {
  className?: string;
  size?: 'lg' | 'md' | 'sm';
}

const ResizeableLoadingSpinner: React.FunctionComponent<LoadingSpinnerProps> = ({
  className,
  size = 'lg',
}) => {
  return (
    <div className={`spinner-container ${className}`}>
      <div className={`loading-spinner loading-spinner__${size}`}></div>
    </div>
  );
};

export default ResizeableLoadingSpinner;
